import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { FooterModule } from './utility/components/footer/footer.module';
import { HeaderModule } from './utility/components/header/header.module';
import { CraftPreviewInterceptor } from './utility/interceptors/preview.interceptor';
import { ApplicationService } from './shared/services/application.service';

/*
  returns a promise which is only resolved if the data set is loaded
*/
export function init(app: ApplicationService): any {
  return () => app.initRoutes();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HammerModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    HeaderModule,
    FooterModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CraftPreviewInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: init,
      deps: [ApplicationService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
